import type { PatientStrings } from '../index';

export const hi: PatientStrings = {
  titleOne: 'आपका नया क्राउन',
  titleMany: 'आपके नए क्राउन',
  tooth: 'दांत',
  teeth: 'दांत',
  both: 'दोनों',
  overview: 'पूरा दृश्य',
  front: 'सामने से',
  leftSide: 'बाईं ओर',
  rightSide: 'दाईं ओर',
  bitingSurface: 'चबाने की सतह',
  show: 'दिखाएँ',
  newCrown: 'नया क्राउन',
  newCrowns: 'नए क्राउन',
  yourTeeth: 'आपके दांत और मसूड़े',
  upperTeeth: 'ऊपर के दांत',
  lowerTeeth: 'नीचे के दांत',
  hint: 'घुमाने के लिए खींचें · ज़ूम के लिए पिंच या स्क्रॉल करें',
  zoomIn: 'पास करें',
  zoomOut: 'दूर करें',
  turnSlowly: 'धीरे-धीरे घुमाएँ',
  stopTurning: 'घुमाना रोकें',
  backToStart: 'शुरुआत पर वापस',
  fullScreen: 'पूरी स्क्रीन',
  exitFullScreen: 'पूरी स्क्रीन से बाहर',
  fromDentist: 'आपके दंत चिकित्सक की ओर से',
  shadeNote: (shade) =>
    `रंग लगभग शेड ${shade} जैसा दिखाया गया है। असली क्राउन का रंग लैब में मिलाया जाता है।`,
  before: 'पहले',
  after: 'बाद में',
  seeInRoom: 'अपने कमरे में देखें',
  arNotSupported: 'क्राउन को अपने कमरे में देखने के लिए यह पेज अपने फ़ोन पर खोलें।',
  appointmentTitle: 'क्राउन लगाने की आपकी अपॉइंटमेंट',
  confirm: 'पुष्टि करें',
  confirmed: 'पुष्टि हो गई — तब मिलते हैं',
  anotherTime: 'दूसरा समय माँगें',
  anotherTimeSent: 'हमने आपके दंत चिकित्सक को बता दिया है कि आपको दूसरा समय चाहिए।',
  language: 'भाषा',
  largerText: 'बड़े अक्षर',
};
